import cookies from './util.cookies';
import db from './util.db';
import store from '@/store';
// import log from './util.log'
// import browser from './util.browser'
// import dataType from './util.type'

// const { VUE_APP_PUBLIC_PATH } = process.env
import { SINGLE_TOKEN_KEY, SINGLE_UUID_KEY } from '@/maps/common';
import { loginByToken, loginByCSDNCode } from '@/api/home';

const util = {
  cookies,
  db,
  // log,
  // browser,
  // dataType
};

util.isMobile = () => {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;
  const mobileKeywords =
    /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i;

  return mobileKeywords.test(userAgent);
};

/**
 * @description 更新标题
 * @param {String} title 标题
 */
util.setBomTitle = function (titleText) {
  const processTitle = process.env.VUE_APP_TITLE || '';
  window.document.title = util.isMobile()
    ? titleText || processTitle
    : `${processTitle}${titleText ? ` | ${titleText}` : ''}`;
};

/**
 * @description 更新标题
 * @param {String} title 标题
 */
util.getTitle = function () {
  return process.env.VUE_APP_TITLE || '';
};

util.getUrlParams = () => {
  var paramString = window.location.href.split('?')[1];
  var params = {};
  if (paramString) {
    var paramPairs = paramString.split('&');

    paramPairs.reduce(function (params, pair) {
      var parts = pair.split('=');
      var key = parts[0];
      var value = decodeURIComponent(parts[1] || '');
      params[key] = value;
      return params;
    }, params);
  }
  console.log(params);
  return params;
};

/**
 * @description 获取当前浏览器存储的token
 */
util.getToken = async (auth) => {
  const singleToken = util.cookies.get(SINGLE_TOKEN_KEY);

  // 因为执行顺序问题，这里的数据直接从localstorage中取
  const isLogin = await store.dispatch(
    'db/get',
    {
      dbName: 'sys',
      path: 'system.isLogin',
      defaultValue: null,
      user: true,
    },
    { root: true },
  );
  const token = await store.dispatch(
    'db/get',
    {
      dbName: 'sys',
      path: 'user.token',
      defaultValue: null,
      user: true,
    },
    { root: true },
  );

  if (!isLogin && singleToken) {
    // 如果当前系统未登录，但是cookies中存在token，则采用token去登录
    await loginByTokenFun(auth);
    return singleToken;
  } else if (isLogin) {
    // 如果当前系统已经登录，并且cookies中存储的token与当前系统存储的token不一致，则采用新的token去刷新登录信息
    if (singleToken && token !== singleToken) {
      await loginByTokenFun(auth);
      return singleToken;
    } else if (!singleToken) {
      // 如果cookies中不存在token，但是系统在登录状态，说明是虚假登录状态，清除登录信息
      util.clearUser();
    } else {
      return singleToken;
    }
  }
};

/**
 * @description 跳转space
 */
util.jumpSpace = (type = '_blank') => {
  // const token = util.cookies.get(TOKEN_KEY);
  let partner = localStorage.getItem('partner');
  if (partner) {
    window.open(process.env.VUE_APP_SPACE_URL + '?partner=' + partner, type);
  } else {
    window.open(process.env.VUE_APP_SPACE_URL, type);
  }
};

/** 清除登录信息 */
util.clearUser = () => {
  util.cookies.remove(SINGLE_TOKEN_KEY, {path: '/', domain: '.mg.xyz'});
  util.cookies.remove(SINGLE_UUID_KEY, {path: '/', domain: '.mg.xyz'});
  store.dispatch('user/setToken', null);
  store.dispatch('user/setUserInfo', null);
  store.dispatch('system/setIsLogin', false);
};

/** 通过单点登录的token进行登录
 * @description
 */
let isloading = false;
const loginByTokenFun = async (auth = true) => {
  if (isloading) return;
  const singleToken = util.cookies.get(SINGLE_TOKEN_KEY);
  const singleUuid = util.cookies.get(SINGLE_UUID_KEY);
  const params = {
    ticket: singleToken,
    uuid: singleUuid,
    toUuid: singleUuid,
    appId: process.env.VUE_APP_ID,
  };
  isloading = true;
  let config = {
    auth: auth,
    showMsg: auth
  }
  const res = await loginByToken(params, config).catch(() => {
    util.clearUser();
  });
  isloading = false;
  if (res && res.data) {
    const { data } = res;

    // 存储在vuex中
    await store.dispatch('user/setToken', singleToken);
    // 设置用户info
    await store.dispatch('user/setUserInfo', data);
    // 设置系统为登录状态
    await store.dispatch('system/setIsLogin', true);
  } else {
    util.clearUser();
  }
};

/** 通过单点登录的token进行登录
 * @description
 */
export const loginByCSDNCodeFun = async code => {
  if (isloading) return;
  const params = {
    code: code,
  };
  isloading = true;
  const res = await loginByCSDNCode(params).catch(() => {
    util.clearUser();
  });
  isloading = false;
  if (res && res.data) {
    const { data } = res;
    let { bindingToken, userInfo } = data;

    // 设置R 空间系统单点登录的token
    util.cookies.set(SINGLE_TOKEN_KEY, userInfo.tokenInfo.ticket, {
      expires: userInfo.tokenInfo.expire / 24 / 3600,
      domain: '.mg.xyz',
    });
    // 设置R 空间系统单点登录的uuid
    util.cookies.set(SINGLE_UUID_KEY, userInfo.userInfo.uuid, {
      expires: userInfo.tokenInfo.expire / 24 / 3600,
      domain: '.mg.xyz',
    });

    // 存储在vuex中
    await store.dispatch('user/setToken', userInfo.tokenInfo.ticket);
    // 设置用户info
    await store.dispatch('user/setUserInfo', userInfo.userInfo);
    await store.dispatch('user/setBindingToken', bindingToken);
    // 设置系统为登录状态
    await store.dispatch('system/setIsLogin', true);
  } else {
    util.clearUser();
  }
};

/** 判断浏览器类型 */
util.getBroswer = () => {
  var userAgent = navigator.userAgent;
  var info = '';
  //判断浏览器版本
  var isOpera = userAgent.indexOf('Opera') > -1; //判断是否Opera浏览器
  var isIE = userAgent.indexOf('compatible') > -1 && userAgent.indexOf('MSIE') > -1 && !isOpera; //判断是否IE浏览器
  var isEdge = userAgent.toLowerCase().indexOf('edg') > -1 && !isIE; //判断是否IE的Edge浏览器
  var isIE11 = userAgent.toLowerCase().indexOf('trident') > -1 && userAgent.indexOf('rv') > -1;

  if (/[Ff]irefox(\/\d+\.\d+)/.test(userAgent)) {
    info = 'Firefox';
  } else if (isIE || isIE11) {
    info += 'IE';
  } else if (isEdge) {
    info += 'Edge';
  } else if (/[Cc]hrome\/\d+/.test(userAgent)) {
    info = 'Chrome';
  } else if (/[Ss]afari/.test(userAgent)) {
    info = 'Safari';
  } else if (isOpera) {
    info = 'Opera';
  } else {
    info += 'unknown';
  }
  return info;
};

/** 判断浏览器类型和版本号 */
util.getBroswerAndVersion = () => {
  var os = navigator.platform;
  var userAgent = navigator.userAgent;
  var info = '';
  var tempArray = '';
  //判断浏览器版本
  var isOpera = userAgent.indexOf('Opera') > -1; //判断是否Opera浏览器
  var isIE = userAgent.indexOf('compatible') > -1 && userAgent.indexOf('MSIE') > -1 && !isOpera; //判断是否IE浏览器
  var isEdge = userAgent.toLowerCase().indexOf('edg') > -1 && !isIE; //判断是否IE的Edge浏览器
  var isIE11 = userAgent.toLowerCase().indexOf('trident') > -1 && userAgent.indexOf('rv') > -1;

  if (/[Ff]irefox(\/\d+\.\d+)/.test(userAgent)) {
    tempArray = /([Ff]irefox)\/(\d+\.\d+)/.exec(userAgent);
    info += tempArray[1] + tempArray[2];
  } else if (isIE) {
    var version = '';
    var reIE = new RegExp('MSIE (\\d+\\.\\d+);');
    reIE.test(userAgent);
    var fIEVersion = parseFloat(RegExp['$1']);
    if (fIEVersion == 7) {
      version = 'IE7';
    } else if (fIEVersion == 8) {
      version = 'IE8';
    } else if (fIEVersion == 9) {
      version = 'IE9';
    } else if (fIEVersion == 10) {
      version = 'IE10';
    } else {
      version = '0';
    }

    info += version;
  } else if (isEdge) {
    info += 'Edge';
  } else if (isIE11) {
    info += 'IE11';
  } else if (/[Cc]hrome\/\d+/.test(userAgent)) {
    tempArray = /([Cc]hrome)\/(\d+)/.exec(userAgent);
    info += tempArray[1] + tempArray[2];
  } else if (/[Vv]ersion\/\d+\.\d+\.\d+(\.\d)* *[Ss]afari/.test(userAgent)) {
    tempArray = /[Vv]ersion\/(\d+\.\d+\.\d+)(\.\d)* *([Ss]afari)/.exec(userAgent);
    info += tempArray[3] + tempArray[1];
  } else if (/[Oo]pera.+[Vv]ersion\/\d+\.\d+/.test(userAgent)) {
    tempArray = /([Oo]pera).+[Vv]ersion\/(\d+)\.\d+/.exec(userAgent);
    info += tempArray[1] + tempArray[2];
  } else {
    info += 'unknown';
  }
  return info;
};

// 是否在微信内置浏览器中
util.isWX = () => {
  const userAgent = navigator.userAgent.toLowerCase();
  return /micromessenger/.test(userAgent);
};

// 是否在QQ内置浏览器中
util.isQQ = () => {
  var userAgent = navigator.userAgent.toLowerCase();
  // 检查userAgent是否包含qq相关的标识
  if (
    userAgent.indexOf('qq/') !== -1 ||
    userAgent.indexOf('mqqbrowser/') !== -1 ||
    userAgent.indexOf('qqbrowser/') !== -1
  ) {
    return true;
  }
  return false;
};

// 是否安卓
util.isAndroid = () => {
  const u = navigator.userAgent;
  return u.indexOf('Android') > -1 || u.indexOf('Linux') > -1;
};

// 是否IOS
util.isIOS = () => {
  const u = navigator.userAgent;
  return !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
};

util.screenRatio = () => {
  return window.innerWidth / window.innerHeight;
};

export default util;
